import difference_in_days from 'date-fns/difference_in_days';
import format from 'date-fns/format';
const minute = 60;
const hours = 60 * minute;
const day = 24 * hours;
/**
 * same as JSON.parse but return undefined when parse error
 *
 * @param jsonString - json string
 * @returns parsed Object or Array, undefined when JSON.parse error
 */
export function JsonParse(jsonString) {
    if (!jsonString) {
        return;
    }
    try {
        const json = JSON.parse(jsonString);
        return json;
    }
    catch (err) {
        return;
    }
}
export function getTimeAgo(time) {
    if (!time)
        return '';
    const now = new Date().getTime();
    const ago = new Date(time * 1000);
    const diff = now / 1000 - time;
    if (diff >= day) {
        if (diff >= 3 * day) {
            const diffDays = difference_in_days(now, ago);
            if (diffDays < 7) {
                return `${diffDays}天前`;
            }
            return format(ago, 'MM-DD');
        }
        if (diff >= 2 * day) {
            return '前天';
        }
        return '昨天';
    }
    if (diff >= hours) {
        return `${Math.floor(diff / hours)}小时前`;
    }
    if (diff >= minute) {
        return `${Math.floor(diff / minute)}分钟前`;
    }
    return '刚刚';
}
const hour = 60 * 60;
const minutes = 60;
export function formatPlayerTime(duration) {
    if (!duration) {
        return '00:00';
    }
    try {
        const dur = Number(duration);
        const h = Math.floor(dur / hour);
        const m = Math.floor((dur % hour) / minutes);
        const s = dur % minutes;
        return `${h ? `${fillZero(h)}:` : ''}${fillZero(m)}:${fillZero(s)}`;
    }
    catch (error) {
        console.error(error);
        return `${duration}`;
    }
}
function fillZero(n) {
    return n <= 9 ? `0${n}` : n;
}
// eslint-disable-next-line max-len
// {"tag_1":{"text":"","font_color":"","background_color":"","font_image_url":"","params":"","params_2":""},"tag_2":{"text":"预","font_color":"#ffffff","background_color":"#ff650f","font_image_url":"","params":"","params_2":""},"tag_3":{"text":"","font_color":"","background_color":"","font_image_url":"","params":"","params_2":""},"tag_4":{"text":"","font_color":"","background_color":"","font_image_url":"","params":"","params_2":""}}
/**
 * 新版角标解析
 *
 * @param imgTag - imgTag ,接口返回中的imgtag_all字段
 * @param position - tag_{0,1,2,3} mapped to top-left top-right bottom-right bottom-left
 * @returns parsed img link
 */
export function parseNewCornerMark(imgTag, position) {
    var _a, _b;
    const tagObject = (_a = JsonParse(imgTag), (_a !== null && _a !== void 0 ? _a : {}));
    const tag = (_b = tagObject[position], (_b !== null && _b !== void 0 ? _b : {}));
    return tag;
}
// 个人中心只需展示右上角的角标，因此只需要tag_2
// https://tapd.woa.com/TenVideo/prong/stories/view/1069995081115743320
export function useNewCornerMark(uniImgTag) {
    if (!uniImgTag) {
        return undefined;
    }
    return parseNewCornerMark(uniImgTag, 'tag_2');
}
// 观看记录中的角标展示逻辑，将角标字段转换为前端需要的字段
export function parseHistoryNewCornerMark(imgTagList) {
    var _a, _b, _c, _d;
    const imgTag = imgTagList.find((item) => item.position === 1);
    return {
        text: (_a = imgTag) === null || _a === void 0 ? void 0 : _a.primeText,
        font_color: (_b = imgTag) === null || _b === void 0 ? void 0 : _b.fontColor,
        background_color: (_c = imgTag) === null || _c === void 0 ? void 0 : _c.bgColor,
        font_image_url: (_d = imgTag) === null || _d === void 0 ? void 0 : _d.frontImageUrl,
    };
}
